import { useState } from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import FullScreenImg from '../fullscreen-img'

interface ChartTab {
  label: string
  imgSrc: string
}

interface ChartTabsProps {
  tabs: ChartTab[]
  id?: string
}

const ChartTabs: React.FC<ChartTabsProps> = ({ tabs, id }) => {
  const [selectedTab, setSelectedTab] = useState(0)

  return (
    <Box id={id}>
      <Tabs
        value={selectedTab}
        onChange={(_, newValue: number) => setSelectedTab(newValue)}
        variant='scrollable'
        scrollButtons='auto'
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          mb: 2,
          '& .MuiTab-root': {
            fontWeight: 'bold',
            textTransform: 'none'
          },
          '& .Mui-selected': {
            color: 'primary.main'
          }
        }}
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} id={`chart-tab-${index}`} />
        ))}
      </Tabs>

      {tabs.map((tab, index) => (
        <Box
          key={index}
          role='tabpanel'
          hidden={selectedTab !== index}
          sx={{
            opacity: selectedTab === index ? 1 : 0,
            transition: 'opacity 0.3s ease-in-out'
          }}
        >
          {selectedTab === index && (
            <FullScreenImg imgSrc={tab.imgSrc} />
          )}
        </Box>
      ))}
    </Box>
  )
}

export default ChartTabs
